import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { LucideIcon } from 'lucide-react';

interface ActivityMetricCardProps {
  title: string;
  thisWeek: number;
  lastWeek: number;
  growth: number;
  icon: LucideIcon;
  color: string;
}

const getGrowthIcon = (growth: number) => {
  if (growth > 0) return <TrendingUp className="h-3 w-3 text-green-600" />;
  if (growth < 0) return <TrendingDown className="h-3 w-3 text-red-600" />;
  return <Minus className="h-3 w-3 text-gray-400" />;
};

const getGrowthColor = (growth: number) => {
  if (growth > 0) return 'text-green-600';
  if (growth < 0) return 'text-red-600';
  return 'text-gray-500';
};

const formatGrowth = (growth: number) => {
  const sign = growth > 0 ? '+' : '';
  return `${sign}${growth}%`;
};

const ActivityMetricCard: React.FC<ActivityMetricCardProps> = ({
  title,
  thisWeek,
  lastWeek,
  growth,
  icon: Icon,
  color
}) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">
          {title}
        </CardTitle>
        <Icon className={`h-4 w-4 ${color}`} />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold mb-1">{thisWeek}</div>
        <div className="flex items-center space-x-2">
          <Badge variant="secondary" className="text-xs">
            Last week: {lastWeek}
          </Badge>
          <div className={`flex items-center space-x-1 text-xs ${getGrowthColor(growth)}`}>
            {getGrowthIcon(growth)}
            <span>{formatGrowth(growth)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityMetricCard;